export const AI_BANNER_VIDEO_URL =
    'https://fiverr-res.cloudinary.com/video/upload/t_fiverr_hd_nl/v1/video-attachments/generic_asset/asset/14957b0be6378e1fd212193f81962000-1774365803723/all%20directors%20for%20gif%20fixed';
export const AI_BANNER_POSTER_URL =
    'https://fiverr-res.cloudinary.com/video/upload/so_0,f_jpg,q_auto,w_1920,c_limit/v1/video-attachments/generic_asset/asset/14957b0be6378e1fd212193f81962000-1774365803723/all%20directors%20for%20gif%20fixed';
export const AI_DIRECTOR_LINK_PATH = '/ai-video';
export const AI_DIRECTOR_UTM_SOURCE = 'listings_ai_video_banner';
export const AI_BANNER_SUB_CATEGORY_IDS = ['545'];
export const AI_BANNER_NESTED_SUB_CATEGORY_IDS = ['2748', '2904'];
